import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import {
  getTotalNumberOfActiveOffers,
  getTotalNumberOfActiveRequests,
} from 'src/app/my-advertisements/store/selectors/my-advertisements.selector';

import * as MyAdvertisementsActions from '../../../store/actions/my-advertisements.actions';

@Component({
  selector: 'app-my-advertisements-table-header',
  templateUrl: './my-advertisements-table-header.component.html',
  styleUrls: ['./my-advertisements-table-header.component.scss'],
  standalone: false,
})
export class MyAdvertisementsTableHeaderComponent {
  private readonly store = inject(Store);

  totalNumberOfActiveOffers$: Observable<number>;
  totalNumberOfActiveRequests$: Observable<number>;

  constructor() {
    this.totalNumberOfActiveOffers$ = this.store.select(getTotalNumberOfActiveOffers);
    this.totalNumberOfActiveRequests$ = this.store.select(getTotalNumberOfActiveRequests);
  }

  tabChange(index: number): void {
    if (index === 0) {
      this.store.dispatch(MyAdvertisementsActions.switchToMyManureOffers());
    } else if (index === 1) {
      this.store.dispatch(MyAdvertisementsActions.switchToMyManureRequests());
    }
  }
}
